const TrackerBaseAuthConstants = Object.freeze({
    storageKeys: {
        accessTokenKey: "access_token",
        idTokenKey: "id_token",
        expiresAtKey: "expires_at"
    },
    claims: {
        namespace: "https://ab21.org/claims/"
    },
    scopes: {
        trackerbaseApiAccess: "params"  // Changed from "access:trackerbase-api" to standard OIDC scope
    }
});

export default TrackerBaseAuthConstants;



//////////////////
// WEBPACK FOOTER
// ./src/services/auth/AuthConstants.js
// module id = nIeW
// module chunks = 1